// extracted by mini-css-extract-plugin
export default {"body":"Card_body__1XgQZ","cellButton":"Card_cellButton__FU5Xw","card":"Card_card__tozaM","members":"Card_members__36JIK"};